export enum REMOTE_CLIENTS_TABLE_COLUMNS {
    LICENSE_ID = 'Id',
    DESCRIPTION = 'ClientInfo',
    CLIENT_ID = 'ClientId',
    ENABLED = 'Enabled',
    ACTIONS = 'Actions',
}

export const REMOTE_CLIENTS_COLUMNS = [
    { name: 'LICENSE_ID', value: REMOTE_CLIENTS_TABLE_COLUMNS.LICENSE_ID },
    { name: 'DESCRIPTION', value: REMOTE_CLIENTS_TABLE_COLUMNS.DESCRIPTION },
    { name: 'CLIENT_ID', value: REMOTE_CLIENTS_TABLE_COLUMNS.CLIENT_ID }
];

export const REMOTE_CLIENTS_TABLE_HEADER = [
    REMOTE_CLIENTS_TABLE_COLUMNS.LICENSE_ID,
    REMOTE_CLIENTS_TABLE_COLUMNS.DESCRIPTION,
    REMOTE_CLIENTS_TABLE_COLUMNS.CLIENT_ID,
    REMOTE_CLIENTS_TABLE_COLUMNS.ENABLED,
    REMOTE_CLIENTS_TABLE_COLUMNS.ACTIONS
];

export const REMOTE_CLIENTS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const REMOTE_CLIENTS_PAGE_DEFAULT_SIZE = 10;
